import { proxyBE } from "./common";

export const pageService = {
  page(slug) {
    return proxyBE.get(`pages/${slug}`);
  },

  saveContactRequest(payload) {
    return proxyBE.post(`pages/form5cfu`, payload);
  },

  saveContactRequest60Cfu(payload) {
    return proxyBE.post(`pages/form60cfu`, payload);
  },

   saveContactRequestMasterMedicina(payload) {
    return proxyBE.post(`pages/master-medicina`, payload);
  },
};
